import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarRef} from "@angular/material/snack-bar";
import {HekaSnackBarComponent} from "ngx-heka-design-lib";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly snackBarDuration = 3000;


  constructor(private snackBar: MatSnackBar) {
  }

  showSuccess(message: string): MatSnackBarRef<any> {
    return this.snackBar.openFromComponent(HekaSnackBarComponent, {
      duration: this.snackBarDuration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {message},
      panelClass: 'success-notification'
    });
  }

  showError(message: string, duration: number = 0): MatSnackBarRef<any> {
    return this.snackBar.openFromComponent(HekaSnackBarComponent, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {message},
      panelClass: 'error-notification'
    });
  }

  isShowingSnackBar(ref ?: MatSnackBarRef<HekaSnackBarComponent>): boolean {
    if (ref) {
      return this.snackBar._openedSnackBarRef != null && this.snackBar._openedSnackBarRef === ref;
    }
    return this.snackBar._openedSnackBarRef != null
  }
}
